import { InjectionToken, inject } from '@angular/core';
import { SettingsStore } from './settings.store';
import { ISettingsStore } from './settings.public';

export const SETTINGS_STORE = new InjectionToken<ISettingsStore>(
    'SETTINGS_STORE',
    {
        providedIn: 'root',
        factory: () => inject(SettingsStore) as ISettingsStore,
    },
);
